import { analyticsEventEmitter } from '@portals/wb-front-analytics-tracker';
import {
  userDataPermissionsSelector,
  userDataSelector,
} from '@wildberries/databus-service-user';
import { getSupplierIdFromCookie } from '../get-supplier-id-from-cookie';
import { getCookie } from '../init-app/_utils/get-cookie';

const ABAC_AB_FEATURE = window.ENVS.AB_EXPERIMENTS_ABAC_FEATURE || 'abGroup';
const APP_VERSION = process.env.CI_COMMIT_TAG || 'v0.0.0';

const additionalParamsGetter = () => {
  const abExperiments =
    userDataPermissionsSelector(window.ENVS.MAIN_ABAC_SCOPE)?.[
      ABAC_AB_FEATURE
    ] || {};

  return {
    idUser: userDataSelector().id,
    idSupplier: getSupplierIdFromCookie({ getCookie }).key,
    // для АБ пока отправляем строкой
    splits: JSON.stringify(abExperiments),
    uiRootVersion: APP_VERSION,
  };
};

export const initAnalytics = () => {
  const counterId = Number(window.ENVS.WB_ANALYTICS_COUNTER_ID);

  analyticsEventEmitter.setAdditionalParamsGetter(additionalParamsGetter);

  analyticsEventEmitter.init({ counterId });
};
